import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
  jsonLd?: Record<string, unknown>[];
}

export default function SEO({
  title,
  description,
  canonical,
  keywords,
  ogTitle,
  ogDescription,
  ogType,
  ogUrl,
  jsonLd,
}: SEOProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    const setProperty = (property: string, content: string) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    if (ogTitle) setProperty('og:title', ogTitle);
    if (ogDescription) setProperty('og:description', ogDescription);
    if (ogType) setProperty('og:type', ogType);
    if (ogUrl) setProperty('og:url', ogUrl);

    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }

    if (jsonLd && jsonLd.length > 0) {
      const existingScripts = document.querySelectorAll('script[data-seo-jsonld]');
      existingScripts.forEach((s) => s.remove());

      jsonLd.forEach((schema) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-seo-jsonld', 'true');
        script.textContent = JSON.stringify(schema);
        document.head.appendChild(script);
      });
    }
  }, [title, description, canonical, keywords, ogTitle, ogDescription, ogType, ogUrl, jsonLd]);

  return null;
}